import React from "react";
import MobilePageLayout from "../components/MobilePageLayout";

const HomePage = ({ onNext }) => {
  return (
    <MobilePageLayout ctaLabel="Next" onCtaClick={() => onNext(null)}>
      <img src="/logo.png" className="logo" alt="LOKRAM" />
      <h2 className="page-title">Emergency Retrieval</h2>
      <p className="text-center">
        Use this option only if the terminal tab did not work properly.
      </p>

      <p className="text-center">
        Please contact the support team first to enable your order for emergency
        retrieval. Once confirmed, continue here to log in and unlock your
        locker.
      </p>
    </MobilePageLayout>
  );
};

export default HomePage;
